import { render, staticRenderFns } from "./Lifeline.vue?vue&type=template&id=bccd94da&scoped=true&"
import script from "./Lifeline.vue?vue&type=script&lang=js&"
export * from "./Lifeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccd94da",
  null
  
)

export default component.exports